// src/components/Pricing.js
import React, { useState } from 'react';
import './Pricing.css';

const Pricing = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    specialty: '',
    noOfProviders: '',
    emrSoftware: '',
    monthlyRevenue: '',
    phone: '',
    email: '',
    challenges: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const specialties = [
    'Cardiology', 'Neurology', 'Pediatrics', 'Dermatology', 'Orthopedics',
    'Ophthalmology', 'Mental Health', 'Nephrology', 'Podiatry', 'Allergy',
    'Rehab', 'Neurosurgery', 'Geriatrics', 'Other'
  ];

  const providerOptions = ['1', '2-5', '6-10', '11-20', '21-50', '50+'];
  const revenueOptions = ['Less than $50k', '$50k - $100k', '$100k - $250k', '$250k - $500k', '$500k - $1M', '$1M+'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://formspree.io/f/xrejwqgl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you! We will contact you shortly with your best rate quote.' });
        setFormData({
          fullName: '', practiceName: '', specialty: '', noOfProviders: '',
          emrSoftware: '', monthlyRevenue: '', phone: '', email: '', challenges: ''
        });
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again or call us directly.' });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
    }
  };

  return (
    <main className="pricing-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">Medical Billing Pricing</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="container">
          <h1 className="pricing-hero-title">Medical Billing Pricing</h1>
        </div>
      </section>

      {/* Pricing Content Section */}
      <section className="pricing-content">
        <div className="container">
          <div className="pricing-info">
            <h2 className="pricing-title">
              Medical Billing <span className="highlight">Pricing</span>
            </h2>
            <p className="pricing-description">
              Provider Care <strong>Billing LLC</strong> is the country's most cost-effective and highly recommended medical 
              billing and Revenue Cycle Management Company. Our medical billing and coding pricing is highly transparent and 
              designed to maximize your revenue. We provide excellent medical billing and coding services starting at just 
              <span className="price-highlight"> 2.49%</span>.
            </p>
            <p className="pricing-description">
              We provide best pricing based upon your specialty, monthly collection, medical billing software you use, and 
              your practice size.
            </p>
            <p className="pricing-cta">
              Would you like to get a best price quote to streamline your medical billing and improve financial health of your practice?
            </p>
            <div className="quote-btn-container">
              <button className="quote-btn" onClick={() => document.getElementById('pricing-form').scrollIntoView({ behavior: 'smooth' })}>
                Get a Quote
              </button>
            </div>
          </div>

          {/* Form Section */}
          <div className="pricing-form-wrapper" id="pricing-form">
            <h3 className="form-title">Complete The Form For Your Best Rate <span className="no-obligation">No Obligation.</span></h3>
            {submitStatus.message && (
              <div className={`status-message ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="text" name="practiceName" placeholder="Practice Name" value={formData.practiceName} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <select name="specialty" value={formData.specialty} onChange={handleChange} required>
                    <option value="">Your Specialty</option>
                    {specialties.map(spec => <option key={spec} value={spec}>{spec}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <select name="noOfProviders" value={formData.noOfProviders} onChange={handleChange} required>
                    <option value="">No Of Providers</option>
                    {providerOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="emrSoftware" placeholder="EMR / Billing Software Used" value={formData.emrSoftware} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <select name="monthlyRevenue" value={formData.monthlyRevenue} onChange={handleChange} required>
                    <option value="">Monthly Revenue</option>
                    {revenueOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group full-width">
                  <textarea name="challenges" rows="4" placeholder="What challenges are you facing?" value={formData.challenges} onChange={handleChange}></textarea>
                </div>
              </div>
              <div className="form-row">
                <button type="submit" className="submit-pricing-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
            
            {/* Disclaimer */}
            <div className="form-disclaimer">
              <p>
                By submitting this form, you agree that Provider Care Billing LLC may contact you via email, phone, or SMS 
                for processing. We may change any required information on this form. Strictly HIPAA compliant. Consent is 
                not required for provision.
              </p>
              <a href="/privacy-policy" className="privacy-link">View our Privacy Policy</a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pricing-cta-section">
        <div className="container">
          <div className="cta-content-pricing">
            <h2>Let's Streamline Your Billing Together</h2>
            <button className="cta-pricing-btn" onClick={() => document.getElementById('pricing-form').scrollIntoView({ behavior: 'smooth' })}>
              Get Your Best Rate Quote →
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Pricing;